import React, { useState, useEffect } from 'react';

import Zoom from '../../../utils/animations/zoom';
const WordCollection = ({ questionId, wordbank }) => {
	let [wordCollection, setWordCollection] = useState([]);

	useEffect(() => {
		let wordCollection = '';
		if (!!wordbank) {
			let splittedWords = wordbank.split('|');
			wordCollection = Object.keys(splittedWords).map(function (bankKey) {
				return (
					<Zoom>
						<button
							aria-label={splittedWords[bankKey]}
							className="btn btn-lg btn-primary mar-btm mar-rgt"
							value={splittedWords[bankKey]}
							key={`${bankKey}_${questionId}`}
							data-id="0"
						>
							{splittedWords[bankKey]}
						</button>
					</Zoom>
				);
			});
		}
		setWordCollection(wordCollection);
	}, [wordbank, questionId]);

	return <div className="converse-pasage-options mar-top">{wordCollection}</div>;
};

export default WordCollection;
